import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './index.scss';
import StripNavLink from './strip-nav-link';
import MainMobile   from 'assets/magazine/icons/main-mobile.svg';
import Video        from 'assets/magazine/icons/video.svg';
import * as Routes  from 'constants/routes';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getMediaPath, decideInitialSlide } from 'app/functions';
import SliderArrow from 'components/common/shared/slider_arrow';

const NavigationStrip = (props) => {
    const texts = useSelector(store => store.config.Translations);
    const deviceState = useSelector(store => store.state.deviceState);
    const categories = useSelector(store => store.data.magazineCategories);
    const [isMobile, setIsMobile] = useState(false);
    const allCategories = getCategories(categories, isMobile, texts);

    useEffect(() => {
        setIsMobile(deviceState === "mobile");
    }, [deviceState]);

    const location = useLocation();
    const { pathname } = location;
    const slickRef = useRef(null);

    const getActiveCategoryId = () => {
        if (!allCategories) return 0;
        const activeItem = allCategories.find((nav) => {
            if (nav.path === '') return pathname === Routes.magazine;
            return pathname.startsWith(Routes.magazine + nav.path);
        });
        return activeItem ? activeItem.id : 99998;
    };

    const isActive = (path) => {
        if (path === '/') {
            return pathname === Routes.magazine;
        }
        return pathname.startsWith(Routes.magazine + path);
    };

    const mobileSliderSettings = {
        rtl: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <SliderArrow direction="next" />,
        prevArrow: <SliderArrow direction="prev" />,
        initialSlide: allCategories
            ? decideInitialSlide(allCategories, 3, getActiveCategoryId())
            : 0,
    };

    useEffect(() => {
        if (isMobile && allCategories) {
            const activeItem = allCategories.find((nav) => {
                if (nav.path === '') return pathname === Routes.magazine;
                return pathname.startsWith(Routes.magazine + nav.path);
            });
            const activeId = activeItem ? activeItem.id : 99998;
            const targetSlide = decideInitialSlide(allCategories, 3, activeId);
            const timer = setTimeout(() => {
                if (slickRef.current) {
                    slickRef.current.slickGoTo(targetSlide);
                }
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [pathname, isMobile, allCategories]);

    if (!allCategories) return null;

    if (isMobile) {
        return (
            <div className="navigation-strip-wrapper navigation-strip-wrapper_slider">
                <div className="slider-category-select magazine-navigation-slider">
                    <Slider
                        ref={slickRef}
                        className="categories-slider magazine-categories-slider"
                        {...mobileSliderSettings}
                    >
                        {allCategories.map((nav, idx) => (
                            <div key={"nav-strip-" + idx} className="magazine-slider-slide">
                                <div className="slide-layout-container">
                                    <StripNavLink
                                        path={nav.path}
                                        icon={nav.media}
                                        text={nav.title}
                                        id={nav.id}
                                        active={isActive(nav.path !== '' ? nav.path : '/')}
                                    />
                                    {idx !== allCategories.length - 1 && <div className="magazine-cell-divider divider-left" aria-hidden="true" />}
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        );
    }

    return (
        <div className="navigation-strip-wrapper">
            {allCategories.map((nav, idx) => (
                <React.Fragment key={"nav-strip-" + idx}>
                    <StripNavLink
                        path={nav.path}
                        icon={nav.media}
                        text={nav.title}
                        id={nav.id}
                        active={isActive(nav.path !== '' ? nav.path : '/')}
                    />
                    {idx < allCategories.length - 1 && idx !== allCategories.length - 2 && <div className="divider"></div>}
                </React.Fragment>
            ))}
        </div>
    );
}

const getCategories = (serverCategories, isMobile, texts) => { 
    if(!serverCategories){
        return undefined;
    }
    const main = {
        path: "",
        title: "ראשי",
        media: isMobile ? MainMobile : "",
        id: 99998,
    }
    const video = {
        path: `/${texts['magazine_video_category']}`,
        media: Video,
        title: texts['magazine_video_category'],
        id: -1,
    }
    const fixedCategories = serverCategories.map((cat) => ({ 
        ...cat, 
        path: `/${cat.title}`,
        media: getMediaPath(cat.media)
    }));
    return [main, ...fixedCategories, video];
}

export default NavigationStrip;